"use client";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from "react";
import { cx } from "../internal/cx.js";
import { DialogHead } from "../internal/DialogHead.js";
import { isBackdropClick, useModalDialog } from "../internal/useDialog.js";
import { useEscapeLayer } from "../internal/layers.js";
import { onePrimary } from "./Layout.js";
/** Side panel over the page (record card). Modal <dialog>: Esc, backdrop click and «×» close it; focus stays inside. */
export function Drawer({ open, onClose, title, icon, headerExtra, footer, size = "md", closeLabel = "Закрыть", children, className }) {
    const ref = useModalDialog(open);
    const titleId = useId();
    useEscapeLayer(open, onClose);
    return _jsx("dialog", { ref: ref, className: cx("jui-drawer", size !== "md" && `jui-drawer--${size}`, className), "aria-labelledby": titleId, onCancel: event => { event.preventDefault(); onClose(); }, onClick: event => { if (isBackdropClick(event))
            onClose(); }, children: open && _jsxs(_Fragment, { children: [_jsx(DialogHead, { titleId: titleId, icon: icon, title: title, extra: headerExtra, closeLabel: closeLabel, onClose: onClose }), _jsx("div", { className: "jui-dialog-body", children: children }), footer && _jsx("footer", { className: "jui-dialog-foot", children: onePrimary(footer) })] }) });
}
